import { createFileRoute } from '@tanstack/react-router';

import { EmailUnverifiedPage } from '@/pages/email-unverified';

export const Route = createFileRoute('/email-unverified')({
    component: EmailUnverifiedPage,
});
